module.exports = __webpack_public_path__ + "img/logo1.da42adec.png";